module.exports = __webpack_public_path__ + "static/media/blackMore.122e2d2f.svg";